import { SmsButton } from "../sms/Sms";
import React, { useState, useEffect } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import EditIcon from "@mui/icons-material/Edit";
import { Modal, CircularProgress } from "@mui/material";
import AddGroups from "./modals/AddVideos";
import useFetch from "../../../../hooks/useFetch";
import { endpoints } from "../../../../api/endpoints";
import moment from "jalali-moment";
import Search from "../../../shares/search/Search";
import { useSearchParams } from "react-router-dom";
import {
  DeleteOutline,
  FactCheckOutlined,
} from "@mui/icons-material";
import {
  PageHeader,
  TableAction,
} from "../../../shares/dashboard/DashboardWidgets";

const Question = () => {
  const [newModal, setNewModal] = useState(false);
  const [edit, setEdit] = useState(null);
  const [questions, setQuestion] = useState();
  const [id, setId] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClose = () => {
    setNewModal(false);
    setEdit(null);
  };
  const handleEdit = (id) => {
    setNewModal(true);
    setEdit(id);
  };

  const getQuestion = useFetch({
    method: "GET",
    safeRead: true,
    url: endpoints.management.exams,
    params: { page: searchParams.get("page") ?? 1, search: searchParams.get("search") ?? "" },
    noHeader: false,
    trigger: true,
    setter: setQuestion,
  });

  const deleteGroup = useFetch({
    method: "DELETE",
    url: `management/exams/${id}/`,
    noHeader: false,
    trigger: false,
    caller: getQuestion,
    argFunc: () => {
      if (questions?.results.length === 1) {
        setSearchParams((prev) => {
          const next = new URLSearchParams(prev);
          next.set("page", Math.max(1, Number(searchParams.get("page") || 1) - 1));
          return next;
        });
      }
      setId(null);
    },
  });

  const columns = [
    { id: "sms", label: "پیامک", render: (row) => <SmsButton kind="exam" id={row.exam_id} /> },
    { id: "ExamName", label: "نام" },
    {
      id: "exam_available_time_start",
      label: "زمان شروع",
      render: (row) =>
        moment(row.exam_available_time_start, "YYYY/MM/DD HH:mm")
          .locale("fa")
          .format("YYYY/MM/DD HH:mm"),
    },
    { id: "exam_duration", label: "زمان" },
    {
      id: "exam_group",
      label: "گروه",
      render: (row) => (
        <span className="rounded-pill bg-surface-sunken px-md py-2xs text-xs text-ink-muted">
          {row.exam_group.name}
        </span>
      ),
    },
    {
      id: "edit",
      label: "ویرایش",
      render: (row) => (
        <TableAction
          icon={EditIcon}
          onClick={() => handleEdit(row.exam_id)}
          label="ویرایش آزمون"
        />
      ),
    },
    {
      id: "delete",
      label: "حذف",
      render: (row) =>
        deleteGroup.loading && id === row.exam_id ? (
          <CircularProgress size="2rem" color="inherit" className="text-danger" />
        ) : (
          <TableAction
            icon={DeleteOutline}
            onClick={() => setId(row.exam_id)}
            label="حذف آزمون"
            tone="danger"
          />
        ),
    },
  ];

  useEffect(() => {
    id && deleteGroup.reFetch();
  }, [id]);

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="آزمون‌ها"
        description="فهرست آزمون‌های ساخته‌شده و زمان‌بندی آن‌ها"
        icon={FactCheckOutlined}
        actionLabel="ساخت آزمون"
        actionTo="/admin/question-cat"
      />

      <div className="flex flex-col gap-lg">
        <Search getFiltered={getQuestion} />

        <ShareTable
          data={questions?.results ?? []}
          columns={columns}
          getPage={getQuestion}
          totalCount={questions?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddGroups close={handleClose} get={getQuestion} edit={edit} />
      </Modal>
    </div>
  );
};

export default Question;
